module.exports = __webpack_public_path__ + "media/images/lb/053-da5e2a80a7ca9820b91dcb184aaaebd2.svg";